module.exports = __webpack_public_path__ + "static/media/parks.bdc82c01.jpg";